'use strict';

/**
 * slider
 */
export const slider = (() => {
    const $carousel = $('.js-carousel');

    /**
     * init
     */
    const init = () => {
        $carousel.slick({
            accessibility: true,
            autoplay: false,
            arrows: true,
            dots: false,
            slidesToShow: 1,
            variableWidth: true,
            centerMode: true,
            focusOnSelect: true,
            prevArrow:
                '<div class="slick-arw slick-arwprev"><img src="./assets/img/icn_anchor@sp.png" alt="前へ"/></div>',
            nextArrow:
                '<div class="slick-arw slick-arwnext"><img src="./assets/img/icn_anchor@sp.png" alt="次へ"/></div>'
        });

        // $carousel.bind('touchstart', function() {
        //     return true;
        // });

        $carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            if (currentSlide !== nextSlide) {
                const $if = $(this)
                    .find('.slick-current')
                    .find('iframe');
                $if[0].contentWindow.postMessage('{"event": "command", "func": "stopVideo", "args": ""}', '*');
                $if.prev('.js-thumb').removeClass('is-hide');
            }
        });
    };

    // public
    return {
        init: init
    };
})();
